import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'

dayjs.extend(relativeTime)
dayjs.extend(duration)

export function useConverters() {
  const releasedAgo = (date: string | Date) => {
    const now = dayjs()
    const d = dayjs(date)
    const days = now.diff(d, 'day')

    if (days === 0) {
      return 'today'
    } else if (days === 1) {
      return 'yesterday'
    } else if (days > 1 && days <= 31) {
      return `${days} days ago`
    } else if (days > 31 && days <= 365) {
      const month = Math.floor(days / 31)
      return `${month} ${month === 1 ? 'month' : 'months'} ago`
    } else {
      return d.fromNow()
    }
  }

  const formatDuration = (seconds: number) => {
    const d = dayjs.duration(seconds, 'seconds')
    const s = d.seconds() < 10 ? `0${d.seconds()}` : `${d.seconds()}`
    const m = d.minutes() < 10 ? `0${d.minutes()}` : `${d.minutes()}`
    const h = d.hours() > 0 ? `${d.hours()}:` : ''
    return `${h}${m}:${s}`
  }

  const millisecondsToTimeStamp = (milliseconds: number) => {
    const seconds = Math.floor(milliseconds / 1000)
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const s = String((seconds % 60).toFixed(3)).padStart(6, '0');
    return `${h}:${m}:${s}`;
  }

  return {
    releasedAgo,
    formatDuration,
    millisecondsToTimeStamp
  }
}
